// --------------------------------------------------------------------------
// Heatmap Legend of CPT page
// --------------------------------------------------------------------------
import React from 'react';
import { Box, Flex, Text, useTheme } from '@chakra-ui/react';
import colormap from 'colormap';

interface HeatmapLegendCPTProps {
  min: number;
  max: number;
}

const HeatmapLegendCPT: React.FC<HeatmapLegendCPTProps> = ({ min, max }) => {
  const cmap = colormap({
    colormap: 'bone',
    nshades: 256,
    format: 'rgba',
    alpha: 1
  });
  const theme = useTheme();

  return (
    <Flex direction="column" align="center">
      <Flex width={'100%'} height={'4px'}>
        {cmap.map((color, index) => (
          <Box 
            key={index} 
            backgroundColor={`rgba(${color[0]}, ${color[1]}, ${color[2]}, ${color[3]})`} 
            flex="1" 
            borderRadius={theme.radii.box}
          />
        ))}
      </Flex>
      <Flex width={'100%'} justify="space-between" align='center'>
        <Text variant={"results"} fontSize={theme.fontSize.info}>{min}</Text>
        <Text variant={"results"} fontSize={theme.fontSize.info}>{max}</Text>
      </Flex>
    </Flex>
  );
};

export default HeatmapLegendCPT;